import { Button, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSecurityStatus } from '../../hooks/security';
import { AlertTypeEnum } from '../../services/V2/gozer';
import { IsMobile } from '../Shared/Functions';

export function HeaderBar ({logo, account}) {
    let { logout } = useSecurityStatus()
    let [alertMessage, setAlertMessage] = useState<any>(null);
    let [showAlert, setShowAlert] = useState<any>(null);

    useEffect(() => {
        setAlertMessage(account?.alertMessages?.find(x => x.alertType === AlertTypeEnum.GENERIC)?.message)
    }, [account])

    return (
        <>
            {showAlert &&
                <Dialog
                    fullWidth
                    onClose={() => { }}
                    open={true}>
                        <DialogTitle>Alert</DialogTitle>
                    <DialogContent>
                        <iframe title="msg" srcDoc={alertMessage} style={{width:"100%", height: "50vh"}} frameBorder="0" />
                        <div>
                            <Button variant="contained" onClick={()=> setShowAlert(false)} color="primary">Ok</Button>
                        </div>
                    </DialogContent>
                </Dialog>
            }
            { IsMobile() ? null : (
                <Grid container style={{ display: "flex", alignItems: "center", backgroundColor: "white", padding: "0px 16px 0px 16px", height: "100px"}}>
                    <Grid item xs={2}>
                        <div>
                            <img className="navbar-logo" src={logo} style={{maxWidth: "250px", maxHeight:"75px"}} alt="" />
                        </div>
                    </Grid>
                    <Grid item xs={7}>
                    </Grid>
                    <Grid item xs={3}>
                        <div style={{height:"100%", width:"95%", textAlign:"right", margin: "15px"}}>
                            <b>
                                <div>{account.customer.fullName}</div>
                                <div>{account.customer.email}</div>
                                <div><Link to="/sign-in" onClick={() => logout()}>Logout</Link></div>
                            </b>
                        </div>
                    </Grid>
                </Grid>
                )
            }
        </>
    );
}